export const exitSlipRegions = {
  right: [{ type: 'accessibility_button' }, { type: 'flagitem_button' }, { type: 'notepad_button' }],
  items: [
    {
      type: 'progress_element',
    },
    {
      type: 'slider_element',
    },
  ],
  bottom: [],
  'bottom-right': [{ type: 'horizontaltoc_element' }, { type: 'next_button' }],
};
